import { Component, OnInit } from '@angular/core';
import moment from 'moment-timezone';

@Component({
  selector: 'app-grid-date-cell',
  templateUrl: './grid-date-cell.component.html',
  styleUrls: ['./grid-date-cell.component.scss'],
})
export class GridDateCellComponent implements OnInit {
  moment = moment;
  data: any;
  fieldName: string;
  formattedDate: string;

  constructor() {}

  ngOnInit() {}
}
